module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./YunNoteView.js"));
	}, "YunNoteView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=YunNoteView!./src/pages/Shop/Home/YunNote/YunNoteView.js
// module id = 937
// module chunks = 438